import { v4 as uuidv4 } from 'uuid';

export const handleFormValue = (e: any, key: string, data: any, setFormData: any) => {
    setFormData({
        ...data,
        [key]: e.target.value,
    })
}

export const generateUUID = () => uuidv4();